/** Mirror of backend/src/modules/sales/split/split-math.ts shareE4For (integer). Used only for live preview; the server decides. */
export function shareE4(discountPct: number, r: { anchorDiscountPct: number; anchorSharePct: number; slopePerPct: number }): number {
  const h = (n: number) => Math.round(n * 100);
  return h(r.anchorSharePct) * 100 - (h(discountPct) - h(r.anchorDiscountPct)) * h(r.slopePerPct);
}

export const sharePctLabel = (e4: number): string => `${(e4 / 10_000).toFixed(2)}%`;

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export function formatIstDay(ymd: string): string {
  const [y, m, d] = ymd.split('-');
  return `${d} ${MONTHS[Number(m) - 1]} ${y}`;
}

export function todayIst(now: Date = new Date()): string {
  return new Date(now.getTime() + 330 * 60 * 1000).toISOString().slice(0, 10);
}
